/**
 * DemoDataBanner — calm, informational chip for "this is demo data".
 *
 * Replaces the previous loud yellowish "Using mock / sandbox data" strip.
 * Designed to inform without alarming the owner — it's not an error,
 * it's a state.
 *
 * Use one per page context (Overview, AI Expert). Never stack.
 */

export function DemoDataBanner({
    text = "Demo data — live MYOB data is not connected yet.",
    testId = "demo-data-banner",
    className = "",
}) {
    return (
        <div
            className={`inline-flex items-center gap-2 rounded-full bg-stone-100 px-3 py-1 text-[12px] text-stone-600 ${className}`.trim()}
            data-testid={testId}
            role="status"
        >
            <span className="w-1.5 h-1.5 rounded-full bg-stone-400" />
            <span>{text}</span>
        </div>
    );
}
